export const PRODUCT_SERVICE_KEY = 'product';
export const PRODUCT_STORE_KEY = 'product';
export const PRODUCT_API_URL = '/api/v1/product/';
